/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { usersRegistrationsModelSchema } from "./usersRegistrationsModelSchema.ts";
import { z } from "zod";

export const adminStatisticModelSchema = z.object({
    "logins": z.object({
    
    }).catchall(z.number().int()).describe("Число входов пользователей за периоды (ключ - временной бакет, значение - число входов за бакет)"),
"listenDuration": z.object({
    
    }).catchall(z.number().int()).describe("Время прослушивания за период (ключ - временной бакет, значение - время прослушивания в секундах за бакет)"),
"usersOnline": z.object({
    
    }).catchall(z.number().int()).describe("Число пользователей онлайн за период (ключ - временной бакет, значение - число пользователей онлайн за бакет)"),
"registrations": z.lazy(() => usersRegistrationsModelSchema).describe("Число регистраций"),
"radioLaunches": z.object({
    
    }).catchall(z.number().int()).describe("Число запусков радио (ключ - временной бакет, значение - число запусков за бакет)")
    })